// [ai] Small Markdown → HTML for the summaries (recording + folder): headings, paragraphs, ul/ol, bold, italic, code, links
// (https, rec:/note: citations as pills, /atlas paths), and [m:ss] / [m:ss–m:ss] stamps that become <a class="ds-time" data-t> seek
// links ([m:ss](rec:…) is a citation, not a stamp). Everything is escaped first, so a summary can never inject markup. Pure string function.
import { parseTs } from "./time";
const esc = (s: string) => s.replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]!);
const TS = "\\d{1,3}:\\d\\d(?::\\d\\d)?";
export function inlineMd(text: string): string {
  let s = esc(text);
  s = s.replace(new RegExp(`\\[(${TS})(?:[–-](${TS}))?\\](?!\\()`, "g"), (m, a: string) => `<a class="ds-time" data-t="${parseTs(a)}">${m.slice(1, -1)}</a>`);
  s = s.replace(/`([^`]+)`/g, "<code>$1</code>");
  s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
  s = s.replace(/\[([^\]]+)\]\(((?:rec|note):[^)\s]+)\)/g, '<a class="ds-cite" href="$2">$1</a>');   // the document click handler opens the player at t / the note at the offset
  s = s.replace(/\[([^\]]+)\]\((\/[^)\s]*)\)/g, '<a href="$2">$1</a>');
  s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/(^|[^*\w])\*([^*\n]+?)\*(?!\w)/g, "$1<em>$2</em>");
  return s;
}
export function mdToHtml(md: string | null | undefined, { dropTitle = false } = {}): string {
  const out: string[] = []; let list: "ul" | "ol" | null = null, para: string[] = [];
  const flushP = () => { if (para.length) { out.push(`<p>${inlineMd(para.join(" "))}</p>`); para = []; } };
  const closeList = () => { if (list) { out.push(`</${list}>`); list = null; } };
  let first = true;
  for (const raw of (md || "").split("\n")) {
    const line = raw.trimEnd();
    if (!line.trim()) { flushP(); closeList(); continue; }
    const h = /^(#{1,4})\s+(.*)$/.exec(line);
    if (h) { flushP(); closeList(); if (!(dropTitle && first)) out.push(`<h${h[1]!.length}>${inlineMd(h[2]!)}</h${h[1]!.length}>`); first = false; continue; }
    first = false;
    const li = /^\s*(?:[-*•]|(\d+)[.)])\s+(.*)$/.exec(line);
    if (li) { flushP(); const kind = li[1] ? "ol" : "ul"; if (list !== kind) { closeList(); list = kind; out.push(`<${kind}>`); } out.push(`<li>${inlineMd(li[2]!)}</li>`); continue; }
    if (list && /^\s{2,}/.test(raw)) { out[out.length - 1] = out[out.length - 1]!.replace(/<\/li>$/, ` ${inlineMd(line.trim())}</li>`); continue; }
    closeList(); para.push(line.trim());
  }
  flushP(); closeList(); return out.join("");
}
